import { useOrganizationSlug } from './useOrganizationSlug';

const useDomainUrl = () => {
    const organizationSlug = useOrganizationSlug();

    const originUrl = window.location.origin;
    const redirectSubUrl = process.env.REACT_APP_REDIRECT_DEV_SUB_URL || '/';

    /**
     * Constructs a domain URL based on the given parameters.
     *
     * @param {string} specificPath - Optional specific path to append to the domain URL.
     * @param {boolean} includeOrganizationSlug - Determines whether to include the organization slug in the URL.
     * @param {boolean} useAbsolutePath - Determines whether to use the absolute path consisting of the origin and redirect sub URL.
     * @returns {string} - The constructed domain URL based on the specified parameters.
     */
    const getDomainUrl = (
        specificPath = '',
        includeOrganizationSlug = true,
        useAbsolutePath = true
    ) => {
        let domainUrl = '';

        domainUrl = useAbsolutePath ? `${originUrl}${redirectSubUrl}` : domainUrl;
        domainUrl = includeOrganizationSlug ? `${domainUrl}${organizationSlug}` : domainUrl;

        return specificPath ? `${domainUrl}/${specificPath}` : domainUrl;
    };

    return { getDomainUrl };
};

export default useDomainUrl;
